/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Assignment data
 * @export
 * @interface AssignVulnerabilityRequest
 */
export interface AssignVulnerabilityRequest {
    /**
     * 
     * @type {string}
     * @memberof AssignVulnerabilityRequest
     */
    effectTenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignVulnerabilityRequest
     */
    assignedTo?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignVulnerabilityRequest
     */
    assignedToEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignVulnerabilityRequest
     */
    assignedToType?: AssignVulnerabilityRequestAssignedToTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AssignVulnerabilityRequest
     */
    reason?: string;
}


/**
 * @export
 */
export const AssignVulnerabilityRequestAssignedToTypeEnum = {
    Individual: 'INDIVIDUAL',
    Team: 'TEAM',
    Group: 'GROUP'
} as const;
export type AssignVulnerabilityRequestAssignedToTypeEnum = typeof AssignVulnerabilityRequestAssignedToTypeEnum[keyof typeof AssignVulnerabilityRequestAssignedToTypeEnum];


/**
 * Check if a given object implements the AssignVulnerabilityRequest interface.
 */
export function instanceOfAssignVulnerabilityRequest(value: object): value is AssignVulnerabilityRequest {
    return true;
}

export function AssignVulnerabilityRequestFromJSON(json: any): AssignVulnerabilityRequest {
    return AssignVulnerabilityRequestFromJSONTyped(json, false);
}

export function AssignVulnerabilityRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignVulnerabilityRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
        'assignedTo': json['assignedTo'] == null ? undefined : json['assignedTo'],
        'assignedToEmail': json['assignedToEmail'] == null ? undefined : json['assignedToEmail'],
        'assignedToType': json['assignedToType'] == null ? undefined : json['assignedToType'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function AssignVulnerabilityRequestToJSON(json: any): AssignVulnerabilityRequest {
    return AssignVulnerabilityRequestToJSONTyped(json, false);
}

export function AssignVulnerabilityRequestToJSONTyped(value?: AssignVulnerabilityRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'effectTenantId': value['effectTenantId'],
        'assignedTo': value['assignedTo'],
        'assignedToEmail': value['assignedToEmail'],
        'assignedToType': value['assignedToType'],
        'reason': value['reason'],
    };
}

